var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("generic-modal", {
    ref: "confirmModal",
    attrs: {
      id: "confirm-delete-segment-modal",
      "modal-dialog-size": "md",
      "modal-dialog-scrollable": false,
      "footer-close-button-text": _vm.$t("global.words.no"),
      "tab-index": null,
    },
    on: { hidden: _vm.handleHidden },
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function () {
          return [_c("h5", [_vm._v(_vm._s(_vm.$t("lists.deleteSegment")))])]
        },
        proxy: true,
      },
      {
        key: "body",
        fn: function () {
          return [
            _c("p", [
              _vm._v(_vm._s(_vm.$t("lists.removeSegmentConfirmation"))),
            ]),
          ]
        },
        proxy: true,
      },
      {
        key: "footer",
        fn: function () {
          return [
            _c(
              "simple-button",
              {
                attrs: {
                  type: "button",
                  "class-name": "btn btn-danger btn-sm",
                  loading: _vm.deletingSegment.loading,
                  "loading-succeeded": _vm.deletingSegment.success,
                },
                on: { click: _vm.handleDeleteSegment },
              },
              [
                _vm._v(
                  "\n      " + _vm._s(_vm.$t("global.words.yes")) + "\n    "
                ),
              ]
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }